export function decimalToDMS(decimal: number, isLat: boolean): string {
  const dir = isLat ? (decimal >= 0 ? 'N' : 'S') : (decimal >= 0 ? 'E' : 'W');
  const abs = Math.abs(decimal);
  const deg = Math.floor(abs);
  const minDec = (abs - deg) * 60;
  const min = minDec.toFixed(4).padStart(7, '0');
  return `${deg}° ${min}' ${dir}`;
}

export function calcolaAreaHa(punti: [number, number][]): number {
  if (punti.length < 3) return 0;

  const LAT_M = 111320;
  const LON_M = 111320 * Math.cos((42 * Math.PI) / 180);

  const coords = punti.map(([lat, lon]) => [lat * LAT_M, lon * LON_M]);

  let area = 0;
  for (let i = 0, j = coords.length - 1; i < coords.length; j = i++) {
    area += coords[j][0] * coords[i][1];
    area -= coords[i][0] * coords[j][1];
  }

  return Math.abs(area / 2) / 10000;
}
export function calcolaPerimetroKm(punti: [number, number][]): number {
  if (punti.length < 2) return 0;

  const toRad = (deg: number) => (deg * Math.PI) / 180;
  const R = 6371; // km

  let distanzaTotale = 0;

  for (let i = 1; i < punti.length; i++) {
    const [lat1, lon1] = punti[i - 1];
    const [lat2, lon2] = punti[i];

    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) *
        Math.cos(toRad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    distanzaTotale += R * c;
  }

  return distanzaTotale;
}

// Ray casting — verifica se un punto è dentro un poligono (coordinate lat/lng)
export function puntoNelPoligono(punto: [number, number], poligono: [number, number][]): boolean {
  if (poligono.length < 3) return false;
  const [px, py] = punto;
  let inside = false;
  for (let i = 0, j = poligono.length - 1; i < poligono.length; j = i++) {
    const [xi, yi] = poligono[i];
    const [xj, yj] = poligono[j];
    if (((yi > py) !== (yj > py)) && px < ((xj - xi) * (py - yi)) / (yj - yi) + xi) {
      inside = !inside;
    }
  }
  return inside;
}

export interface PerimetroMetadata {
  tipoVegetazione?: string;
  noteOperative?: string;
  innesco?: [number, number] | null;
}

export function esportaGeoJSON(punti: [number, number][], areaHa: number, meta?: PerimetroMetadata): void {
  const areaM2 = Math.round(areaHa * 10000);
  const geojson = {
    type: "FeatureCollection",
    features: [
      {
        type: "Feature",
        properties: {
          name: "Perimetro Incendio",
          areaHa: Math.round(areaHa * 10) / 10,
          areaM2,
          data: new Date().toISOString(),
          sistema: "DOS518 — IRTILAC S.r.l.",
          linea: "Linea Guida AIB n.5 — Linea 5C",
          ...(meta?.tipoVegetazione ? { tipoVegetazione: meta.tipoVegetazione } : {}),
          ...(meta?.noteOperative   ? { note: meta.noteOperative }              : {}),
          ...(meta?.innesco         ? { innescoLat: meta.innesco[0], innescoLon: meta.innesco[1] } : {}),
        },
        geometry: {
          type: "Polygon",
          coordinates: [[...punti.map(([lat, lon]) => [lon, lat]), [punti[0][1], punti[0][0]]]],
        },
      },
    ],
  };

  const blob = new Blob([JSON.stringify(geojson, null, 2)], {
    type: "application/geo+json",
  });

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `DOS518_Perimetro_${new Date().toISOString().slice(0, 10)}.geojson`;
  a.click();
  URL.revokeObjectURL(url);
}